

import "./styles.scss";

export const Footer = () => { // Define the actual props needed in the index file

    const year = new Date().getFullYear();

    return (
        <footer>
            <div>
            <div className="flex items-center justify-center flex-row flex-wrap space-x-4">
                    <a href="https://www.merchology.com/pages/contact-us" target="_blank" rel="noreferrer" className="store-link text-merch-dark-gray">Contact Us</a>
                    <a href="https://www.merchology.com/pages/products-sizing-tabs" target="_blank" rel="noreferrer" className="store-link text-merch-dark-gray">Sizing</a>
                    <a href="https://www.merchology.com/pages/merch-lookbooks" target="_blank" rel="noreferrer" className="store-link text-merch-dark-gray">Lookbooks</a>
                    <a href="https://www.merchology.com/pages/our-process" target="_blank" rel="noreferrer" className="store-link text-merch-dark-gray">Our Process</a>
                    <a href="https://www.merchology.com/"  target="_blank" rel="noreferrer" className="mt-4 md:mt-0 text-center">Powered by <b>Merchology.com</b> ©{year} - All rights reserved.</a>
            </div>
            </div>
        </footer>
    )
}